<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/plan/shopping'">
      <ZuiHeader/>
      <SubPageTemplate page-title="购的开心" dynamically-tab wenqun-item buy-sub-img list-title :pid="$cid.play.gouDeKaiXin" :default-tab-id="tabId"
                       :page-size="3" type="article" :video-mask="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/plan/shopping/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/plan/shopping.vue